<template>
  <div class="device-list">
    <empty-box class="query-form">
      <a-form-model :model="searchForm" layout="inline" ref="searchForm">
        <a-form-model-item label="app类型" prop="appType">
          <a-select v-model="searchForm.appType" placeholder="请选择" class="w140" @change="handleQuery">
            <a-select-option value="DYNAMIC_SIGNAL_ANALYSER">动态信号分析</a-select-option>
            <a-select-option value="SOUND_COLLECTION">声音采集</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="设备型号" prop="deviceModel">
          <a-input class="w140" v-model="searchForm.deviceModel" placeholder="请输入" allowClear />
        </a-form-model-item>
        <a-form-model-item label="设备编号" prop="deviceNo">
          <a-input class="w140" v-model="searchForm.deviceNo" placeholder="请输入" allowClear />
        </a-form-model-item>
        <a-form-model-item label="用户手机号" prop="userPhone">
          <a-input class="w140" :maxLength="11" v-model="searchForm.userPhone" placeholder="请输入" allowClear />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleQuery">查询</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="resetForm">重置</a-button>
        </a-form-model-item>
      </a-form-model>
    </empty-box>

    <div class="my-list" ref="list">
      <empty-box class="my-list-item" v-for="(item, index) in list" :key="index">
        <a-descriptions class="my-descriptions">
          <a-descriptions-item label="设备型号">{{item.deviceModel}}</a-descriptions-item>
          <a-descriptions-item label="设备编号">{{item.deviceNo}}</a-descriptions-item>
          <a-descriptions-item label="绑定设备编号">{{item.bindDeviceNo}}</a-descriptions-item>
          <a-descriptions-item label="绑定设备名称">{{item.bindDeviceName}}</a-descriptions-item>
          <a-descriptions-item label="绑定手机号">{{item.bindUser || '-'}}</a-descriptions-item>
          <a-descriptions-item label="绑定时间">{{item.bindTime | timeFormat}}</a-descriptions-item>
        </a-descriptions>

        <div class="more-container" :ref="`more-container_${index}`">
          <div class="more-container-content" :ref="`more-container-content_${index}`">
            <span class="table-name">功能授权</span>
            <a-table
              class="my-table"
              :columns="columns"
              :dataSource="item.functions"
              :pagination="false"
              :rowKey="(record, index) => index"
            >
              <span slot="startTime" slot-scope="text">{{moment(text).format("YYYY-MM-DD HH:mm:ss")}}</span>
              <span slot="endTime" slot-scope="text">{{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : '-'}}</span>
              <template slot="action" slot-scope="record">
                <a-button type="link" @click="handleEdit(record, item)">修改</a-button>
              </template>
            </a-table>
          </div>
        </div>

        <a-button class="spread-btn" type="link" @click="clickSpread(index)">
          <span>{{item.spread ? '收起' : '展开'}}</span>
          <a-icon :type="item.spread ? 'up' : 'down'" />
        </a-button>
      </empty-box>
    </div>

    <pagination
      size="small"
      :total="page.total"
      :current.sync="page.current"
      :page-size.sync="page.pageSize"
      @pagination="getList"
    />

    <a-modal
      v-model="visible"
      title="修改设备授权信息"
      :width="600"
      @ok="handleEditOk"
      @canle="visible = false"
    >
      <a-form-model ref="editFormRef" :model="editForm" :rules="editRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="设备">
          <span>{{ editForm.deviceModel }}({{ editForm.deviceNo }})</span>
        </a-form-model-item>
        <a-form-model-item label="授权功能">
          <span>{{ editForm.functionName }}</span>
        </a-form-model-item>
        <a-form-model-item label="授权开始时间" prop="startTime">
          <a-date-picker
            v-model="editForm.startTime"
            format="YYYY-MM-DD HH:mm:ss"
            :showTime="{ defaultValue: moment().startOf('day') }"
            style="width: 100%"
            placeholder="请选择授权开始时间"
            @change="handleStartTimeChange"
          />
        </a-form-model-item>
        <a-form-model-item label="授权结束时间" prop="endTime">
          <a-date-picker
            v-model="editForm.endTime"
            format="YYYY-MM-DD HH:mm:ss"
            :showTime="{ defaultValue: moment().endOf('day') }"
            style="width: 100%"
            placeholder="请选择授权结束时间（为空表示永久）"
            :allowClear="true"
            :disabledDate="disabledEndDate"
          />
          <div style="color: #999; font-size: 12px; margin-top: 4px;">留空表示永久有效</div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { queryDeviceBindAllList, editDeviceBind } from '@/api/api'
import moment from 'moment'
import Pagination from '@/components/Pagination';
const columns = [
  {
    title: '功能名称',
    dataIndex: 'functionName',
  },
  {
    title: '授权开始时间',
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' },
  },
  {
    title: '授权结束时间',
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]


export default {
  components: { Pagination },
  data() {
    return {
      moment,
      searchForm: {
        appType: undefined,
        deviceModel: '',
        deviceNo: '',
        userPhone: ''
      },
      page: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      list: [],
      columns,
      visible: false,
      spread: false,
      editForm: {},
      editRules: {
        startTime: [
          { required: true, message: '请选择授权开始时间', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value && this.editForm.endTime) {
                if (moment(value).isAfter(moment(this.editForm.endTime))) {
                  callback(new Error('开始时间不能大于结束时间'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        endTime: [
          {
            validator: (rule, value, callback) => {
              if (value && this.editForm.startTime) {
                if (moment(value).isBefore(moment(this.editForm.startTime))) {
                  callback(new Error('结束时间不能小于开始时间'))
                } else {
                  callback()
                }
              } else {
                // 结束时间为空表示永久，允许为空
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {

    // 获取列表
    getList() {
      const para = {
        keys: {
          appType: this.searchForm.appType,
          deviceModel: this.searchForm.deviceModel,
          deviceNo: this.searchForm.deviceNo,
          userPhone: this.searchForm.userPhone,
        },
        page: {
          current: this.page.current,
          size: this.page.pageSize
        }
      }

      // 保存当前展开状态（使用设备编号作为唯一标识）
      const spreadMap = {}
      this.list.forEach((item, index) => {
        if (item.spread && item.deviceNo) {
          spreadMap[item.deviceNo] = true
        }
      })

      queryDeviceBindAllList(para).then(({ response }) => {
        const { records, total } = response
        this.list = (records || []).map(item => {
          const deviceNo = item.deviceNo || (item.bindDeviceInfo && item.bindDeviceInfo.deviceNo)
          return {
            ...item,
            ...item.bindDeviceInfo,
            spread: spreadMap[deviceNo] || false
          }
        })
        this.page.total = Number(total)
        this.$refs['list'].scrollTo({ top: 0, behavior: 'smooth' })
        
        // 恢复展开状态的UI
        this.$nextTick(() => {
          this.list.forEach((item, index) => {
            if (item.spread) {
              const containerRef = this.$refs[`more-container_${index}`]
              const contentRef = this.$refs[`more-container-content_${index}`]
              if (containerRef && containerRef[0] && contentRef && contentRef[0]) {
                containerRef[0].style.height = contentRef[0].clientHeight + 'px'
              }
            }
          })
        })
      })
    },

    handleQuery() {
      this.page.current = 1
      this.getList()
    },
    resetForm() {
      this.$refs['searchForm'].resetFields()
      this.page.current = 1
      this.getList()
    },

    clickSpread(index) {
      let spread = !this.list[index].spread
      this.$set(this.list[index], 'spread', spread)
      if (spread) {
        this.$refs[`more-container_${index}`][0].style.height =
        this.$refs[`more-container-content_${index}`][0].clientHeight + 'px'
      } else {
        this.$refs[`more-container_${index}`][0].style.height = '0px'
      }
    },

    // 修改
    handleEdit(record, item) {
      this.editForm = Object.assign({}, record)
      this.editForm.deviceModel = item.deviceModel
      this.editForm.deviceNo = item.deviceNo
      this.$set(this.editForm, 'startTime', moment(record.startTime))
      this.$set(this.editForm, 'endTime', record.endTime ? moment(record.endTime) : null)
      this.visible = true
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },

    // 开始时间变化时，重新验证结束时间
    handleStartTimeChange() {
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.validateField('endTime')
        }
      })
    },

    // 禁用结束时间选择器中早于开始时间的日期
    disabledEndDate(current) {
      if (!this.editForm.startTime) {
        return false
      }
      return current && current < moment(this.editForm.startTime).startOf('day')
    },

    handleEditOk() {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) return false

        const para = {
          id: this.editForm.id,
          startTime: this.editForm.startTime ? this.editForm.startTime.valueOf() : null,
          endTime: this.editForm.endTime ? this.editForm.endTime.valueOf() : null
        }

        editDeviceBind(para).then(({ error }) => {
          if (error.code == 0) {
            this.$message.success(error.msg)
            this.visible = false
            this.getList()
          }
        })
      })
    }
  },

  created() {
    this.getList()
  }
}
</script>

<style lang="less" scoped>
  .info {
    padding: 30px 0;
  }
  .spread-btn {
    display: block;
    margin: 0 auto;
  }
  .more-container {
    height: 0px;
    overflow: hidden;
    transition: all 0.6s;
    box-sizing: border-box;
    .more-container-content {
      padding-bottom: 24px;
      box-sizing: border-box;
    }
  }
  .table-name {
    display: block;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    padding: 24px 0px;
  }
  .un-bind {
    color: #f5222d;
  }
  .device-list {
    display: flex;
    flex-direction: column;
    .query-form,
    .my-list-item{
      margin: 0 0 24px 0;
    }
    .my-list {
      height: calc(100vh - 326px);
      overflow-y: scroll;
    }
  }
</style>